import CreateModule from "../components/CreateModule";
import Jobs from "../components/Jobs";
import { useEffect } from "react";

function HomePage() {
  useEffect(() => {
    document.getElementsByTagName("body")[0].style.backgroundColor = "honeydew";
  }, []);
  return (
    <main>
      <h1>WIS Service</h1>
      <Jobs />
      <CreateModule />
    </main>
  );
}

export default HomePage;
